import { useOutletContext } from 'react-router-dom'
import { ContactsPanel } from '../components/ContactsPanel'

export function ContactsPage() {
  const { socket } = useOutletContext() || {}
  return (
    <section className="section">
      <h2>Contacts</h2>
      <ContactsPanel socket={socket} />
    </section>
  )
}
